import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/energy/4_01.jpg';
import _imports_1 from '@/assets/img/energy/4_01-750.jpg';
import _imports_2 from '@/assets/img/energy/4_02.jpg';
import _imports_3 from '@/assets/img/energy/4_02-750.jpg';
import _imports_4 from '@/assets/img/energy/4_03.jpg';
import _imports_5 from '@/assets/img/energy/4_03-750.jpg';
import _imports_6 from '@/assets/img/energy/4_04.jpg';
import _imports_7 from '@/assets/img/energy/4_04-750.jpg';
import _imports_8 from '@/assets/img/energy/4_05.jpg';
import _imports_9 from '@/assets/img/energy/4_05-750.jpg';
const _withScopeId = n => (_pushScopeId("data-v-52de9ac2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "partner"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hidden-xs-only banner",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hidden-sm-and-up banner",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"\" data-v-52de9ac2><img class=\"hidden-xs-only\" src=\"" + _imports_2 + "\" data-v-52de9ac2> <img class=\"hidden-sm-and-up\" src=\"" + _imports_3 + "\" alt=\"\" data-v-52de9ac2></div><div class=\"\" data-v-52de9ac2><img class=\"hidden-xs-only\" src=\"" + _imports_4 + "\" data-v-52de9ac2> <img class=\"hidden-sm-and-up\" src=\"" + _imports_5 + "\" alt=\"\" data-v-52de9ac2></div><div class=\"\" data-v-52de9ac2><img class=\"hidden-xs-only\" src=\"" + _imports_6 + "\" data-v-52de9ac2> <img class=\"hidden-sm-and-up\" src=\"" + _imports_7 + "\" alt=\"\" data-v-52de9ac2></div>", 3);
import { useRouter } from "vue-router";
const __default__ = {
  metaInfo: {
    title: '智悦节能-京奇数据智慧营销',
    meta: [{
      name: "description",
      content: "智悦节能，智慧节能新选择！四川京奇数据科技有限公司凭借先进的节能技术和大数据应用，为住宅、商场、写字楼等场所提供一体化的智慧照明解决方案。通过高光效专利技术、智能化场景控制和物联网传感技术，我们帮助客户实现平均节能60%-80%，同时确保“0”投入降本增效。了解如何通过智悦节能达成“既省电、又省钱、亮度高、体验好”的节能目标，共创绿色未来。"
    }, {
      name: "keywords",
      content: "智悦节能、智慧照明解决方案、节能改造、智慧节能项目、高光效专利技术、智能化场景控制、物联网传感技术、节能服务、照明节能、商业节能解决方案、写字楼节能、住宅节能、物业节能、绿色节能、节能减排、智慧照明、节能照明产品、智慧照明系统、节能技术应用、京小电节能"
    }],
    link: [{
      rel: '',
      href: ''
    }]
  }
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Energy',
  setup(__props) {
    const router = useRouter();
    const toUrl = () => {
      router.push({
        name: "login"
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "banner_box",
        style: {
          "cursor": "pointer"
        },
        onClick: toUrl
      }, _hoisted_4), _hoisted_5, _createElementVNode("div", {
        class: ""
      }, [_createElementVNode("img", {
        class: "hidden-xs-only",
        src: _imports_8,
        style: {
          "cursor": "pointer"
        },
        onClick: toUrl
      }), _createElementVNode("img", {
        class: "hidden-sm-and-up",
        src: _imports_9,
        style: {
          "cursor": "pointer"
        },
        onClick: toUrl
      })])]);
    };
  }
});